import { AxiosError, AxiosResponse } from "axios";
import React from "react";
import _ from "lodash";
import { jsPDF } from "jspdf";
import 'promise-polyfill/src/polyfill';
import html2canvas from 'html2canvas';
import { BankUserContext } from "../../../bankUserContext";
import { LeadDetailsModel, clientNotes } from "../../../models/Lead/LeadDetails";
import SpinnerModel from "../../../commonfields/SpinnerModel";
import Service from "../../../services";
import { SubCategoryQuestion } from "./Question";
import { WithRouterProps, withRouter } from "../../shared/WithRouter";
import { StateProps } from "./QuestionarieComponent";
import QuestionnaireReportComponent from "./QuestionnaireReportComponent";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { catchError } from "../../../utils/Utils";
import { redirect } from "react-router-dom";
import { TrackersEnum } from "../../../models/TrackerModel";
import { RoutesEnum } from "../../../utils/RoutesUtil";
import moment from "moment";





interface ReviewSummaryReportPageState {
  categoriesData: Array<SubCategoryQuestion>;
  flaggedData: Array<SubCategoryQuestion>;
  clientNotes: clientNotes;
  leadDetails: any;
  loader: boolean;
recommendationDetails:any;
showmodal: boolean;
approveStatus: any;
}
class ReviewSummaryReportPage extends React.Component< WithRouterProps<unknown>,ReviewSummaryReportPageState

> {
  Service:  Service; 
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  myElementRef: React.RefObject<any>;
  constructor(props: any) {
    super(props);
    this.Service = new Service();
    this.myElementRef = React.createRef();
    this.state = {
      categoriesData: [],
      flaggedData: [],
      clientNotes: { notes: null },
      leadDetails: null,
      loader: true,
      recommendationDetails:{},
      showmodal: false,    
      approveStatus: {},
    };
  }
  clientProductId = this.props.params.clientProductId;
  clientId = this.props.params.clientId;
  componentDidMount() { 
    this.getComplinaceQuestionsByClientId();
    this.getClientNotes();
    this.getClientDetails();  
    
   
  } 
  // componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<ReviewSummaryReportPageState>, snapshot?: any): void {
  //  if((this.state.approveStatus === "Approve" || this.state.approveStatus === "Decline") && this.state.approveStatus !== prevState.approveStatus){
   
  //  }
  // }
  
   approveClient = async (reviewStatus: string, canvasRef:any) => {
    try {
      if (!this.props?.params.clientProductId) return;


      await this.Service.postSubmitCompliance(this.props?.params.clientProductId, reviewStatus);

      const payload = {
        //"orgId": this.context.bankuserDetails?.organization.orgId,
        "screen": "getAcceptButtonStatus",
        "clientProductId": this.props?.params.clientProductId,
        "sections": "getAcceptStatus",
        "isJsonReturnObject": false
      };


      const response = await this.Service.getAcceptStatus(payload);

      this.setState({showmodal:(false)});

      const data = {

        "screen": "getClientId",
        "sections": "getClientIdByClientProductId",
        "clientProductsId": this.props?.params.clientProductId,
        "isJsonReturnObject": false
      };

      const response2 = await this.Service.clientIdByClientProductId(data);
      await this.Service.getRecommendationDetails(this.props?.params.clientProductId).then((res:any)=>{    
        this.setState({recommendationDetails:res.data});
    })
     
       //this.generateAndUploadPdf()  
       setTimeout(()=>{
        this.generateAndUploadPdf(canvasRef);
       }, 100);  
       setTimeout(()=>{
        this.backtoUnderwriting(); 
       }, 500); 
       
      if (response2.data[0].clientid) {
        const { clientid } = response2.data[0];
        const destination = `/${RoutesEnum.TRACKER}/${(TrackersEnum.UNDERWRITING)}${clientid}/${this.props?.params.clientProductId}`;
        redirect(destination);
      }
      
      // await getReviewProgress();
      // await getComplianceOverallPercentage();
      // bankUserContext.updateComplainceDashboardPage(true);


    } catch (error) {
      catchError(error, true);
    }
  };
 
  backtoUnderwriting() {  
    
    let url = `/${RoutesEnum.TRACKER}/${(TrackersEnum.UNDERWRITING)}`;  
    
      const selectedProductRaw = sessionStorage.getItem("selectedProduct");
      if (selectedProductRaw) {
        const selectedProduct = JSON.parse(selectedProductRaw);
        if (selectedProduct) {
          url = `${url}/${selectedProduct?.orgLevelProductId}`;
        
      }
    }
  
    this.props.navigate(url);
  };


  getComplinaceQuestionsByClientId=()=>{
    this.Service.getComplinaceQuestionsByClientId(this.props.params.clientId, this.props.params.clientProductId).then(
        (response:AxiosResponse<Array<SubCategoryQuestion>>)=> {
          const clonedData = _.cloneDeep(response.data);
          const acceptedData = clonedData.map(category=>{
                                    category.questions =  category.questions.filter(m=>m.reviewAccepted== true);
                                    return category;  
                                })
          const flaggedData = response.data.map(category=>{
                                    category.questions =  category.questions.filter(m=>m.reviewFlagged== true || 
                                    (m.reviewNotes && m.reviewNotes!=''));
                                    return category;  
                                })
          this.setState({categoriesData: acceptedData, flaggedData: flaggedData, loader:false});
    })
    this.Service.getRecommendationDetails(this.props?.params.clientProductId).then((res:any)=>{    
        this.setState({recommendationDetails:res.data});
    })
}

  getClientNotes = () => {
    this.Service.getClientNotes(this.props?.params.clientId).then(
      (response: AxiosResponse<clientNotes>) => {
        this.setState({
          clientNotes: response.data,
        });
      }
    );
  };
  getClientDetails() {
    this.Service.getClientLeadInfoDetails(this.props?.params.clientProductId).then(
      (response: AxiosResponse<LeadDetailsModel>) => {
        if (response.data) {             
          this.setState({ leadDetails: response.data });
        }
      }
    );
  }
   generateAndUploadPdf = async  (canvasRef:any) => {
    this.setState({ loader: true })

  var doc = new jsPDF("p", "mm", "a4");
  
  html2canvas(canvasRef).then((canvas:any)=>{
    var imgData = canvas.toDataURL('image/jpeg', 1.0);   
    var pageHeight = 300;  
    var imgWidth = 210 ; 
    var imgHeight = canvas.height * imgWidth / canvas.width;
    var heightLeft = imgHeight;
    var position = 15;

    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight,"","MEDIUM");        
        heightLeft -= pageHeight; 
    }
     //doc.output('dataurlnewwindow');
     //doc.save(Date.now() +'.pdf');
    const payload = {
      "orgId": this.context?.bankuserDetails?.organization.orgId,
      "clientId":this.props.params.clientId,
      "clientProductId":this.props.params.clientProductId,
      
    }
      // const check = doc.setFontSize(25);
      const binaryPdf = doc.output('blob');



    
      this.Service
      .uploadSummaryReport(binaryPdf, payload)
      .then((response:any) => {
        this.setState({ loader: false })
        // this.backtoUnderwriting()
      })
  })
  
  };
  
  render() {
    return (
      <React.Fragment>       
        {this.state.loader && (
          <SpinnerModel
            value={""}
            color={"primary"}
            size={""}
            type={"border"}
          />
        )}      
        {!this.state.loader && (
          <div id="summaryReport" ref={this.myElementRef} >
          {/* onClick={this.generateAndUploadPdf} */}
          <div className="summary-report-container" >   
          
            <div className="summary-report"> 
            <div className="report">  </div>
            {this.state.clientNotes.notes && (
              <>
                <h4 className="bold-side-heading">Review Comments</h4>
                <p className="mb-5">{this.state.clientNotes.notes}</p>
              </>
            )}             
             <div><h2 className="summary-heading">Summary Findings Report</h2>
            {this.state.leadDetails && 
                <>
                    <h2 className="client-name">{this.state.leadDetails.company}</h2></>} 
                  </div>
                    <div className="recommended-status">                 
                      {this.state.recommendationDetails?.recommendation ?
                      <> <p className="mb-1">Date : { moment(this.state.recommendationDetails.date,"DD-MM-YYYY").format('M/DD/YY')}</p>
                        <p className="mb-1">Reviewer: {this.state.recommendationDetails?.reviewer}</p>
                        <p className="mb-1">
                            Recommendations: 
                        <span className="approved mb-1">{this.state.recommendationDetails?.recommendation}</span></p>
                     
                        </>:
                         <div>
                        <button
                          className="approvebtn"
                          onClick={() => {
                            this.setState({showmodal:(true)});
                            this.setState({approveStatus:("Approve")});
                          }}
                     
                        >
                          Approve
                        </button>
                        <button
                          className="declinebtn"
                          onClick={() => {
                            this.setState({showmodal:(true)});
                            this.setState({approveStatus:("Decline")});                            
                          }}
                       
                        >
                          Decline
                        </button>
                        </div>
  }
                        
                    </div>  
                                   
             </div> 
          
                
           
          <div className="review-report">
            {this.state.flaggedData.length > 0 &&
              this.state.flaggedData.map((category:any) => {
                return (
                  <>
                    {category.questions.length > 0 && (
                      <>
                        <h4 className="bold-side-heading">
                          Summary: {category.categoryName}/{category.name}{" "}
                        </h4>
                        <div>
                          <span>Comments:</span>
                          <p className="d-inline">
                            {category.categoryComments}
                          </p>
                        </div>
                        <QuestionnaireReportComponent
                          questionsData={category.questions}
                          refreshQuestionsData={false}
                          disableFields={true}
                          formName={`${category.name}_${category.name}`}
                          clientDetails={this.state.leadDetails}
                          showMessageAndHistory={false}
                          
                        />
                      </>
                    )}
                  </>
                );
              })}
            <h2 className="appendix-heading">Appendix (All Responses)</h2>
            {this.state.categoriesData.length > 0 &&
              this.state.categoriesData.map((category:any) => {
                return (
                  <>                  
                    {category.questions.length > 0 && (
                      <>
                        <h4 className="category-title">
                          {category.categoryName}/{category.name}{" "}
                        </h4>
                         <div>
                          <span>Comments:</span>
                          <p className="d-inline">
                            {category.categoryComments}
                          </p>
                        </div>
                        <hr />
                        <QuestionnaireReportComponent
                              questionsData={category.questions}
                              refreshQuestionsData={false}
                              disableFields={true}
                              formName={`${category.name}_${category.name}`}
                              clientDetails={this.state.leadDetails}
                              showMessageAndHistory={true}
                        />
                      </>
                    )}
                  </>
                
                );
              })}
              </div>
               <Modal
          className="popup-modal inviteModal approveAppModal"
          size="md"
          isOpen={this.state.showmodal}
          toggle={() =>this.setState({showmodal:!(this.state.showmodal)})}
        >
          <ModalHeader
            className="modalheaderSendingInvitation"
            toggle={() => this.setState({showmodal:!(this.state.showmodal)})}
          >
            {" "}
            {this.state.approveStatus} Application ?
          </ModalHeader>
          <ModalBody>
            {this.state.approveStatus === "Approve" ? (
              <p>
                This application will be approved and sent for <br />
                account creation. This action cannot be undone.
              </p>
            ) : (
              <p>
                This application will be declined.
                <br />
                This action cannot be undone.
              </p>
            )}
            <div className="footer">
              <button className="cancelBtn" onClick={() => this.setState({showmodal:(false)})}>
                Cancel
              </button>
              <button
                className={
                 this.state.approveStatus === "Approve" ? `approvebtn` : `declineBtn`
                }
                onClick={() =>this.approveClient(this.state.approveStatus, this.myElementRef.current )}
              >
                {this.state.approveStatus}
              </button>
            </div>
          </ModalBody>
        </Modal>    
        
          </div>
          </div>
        )}
       
      </React.Fragment>
    );
  }
}
export default withRouter<WithRouterProps<unknown>>(ReviewSummaryReportPage);


